import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this.heading}}", {
  moduleName: "select-kit/components/toolbar-popup-menu-options/toolbar-popup-menu-options-heading.hbs"
});